export const APP_TYPES = {
  WEB_APP: "WEB_APP"
};
